import * as React from 'react';
import { useParams } from 'react-router';
import { ArticlePageType } from '../../../../utils/context/DeliveryContext';

import { useDeliveryContext } from '../../../../utils/hooks/useDeliveryContext';
import { Seo } from '../../../../utils/seo/Index';
import { FooterOverride } from '../../../layout/FooterOverride';
import { Page } from '../../../layout/Page';
import { Button } from '../../../ui/button/Button';
import { ButtonGroup } from '../../../ui/button/ButtonGroup';
import { ButtonGroupColumn } from '../../../ui/button/ButtonGroupColumn';
import { Hero } from '../../../ui/hero/Index';
import { Heading } from '../../../ui/text/Heading';
import { ArticleContent } from '../../../containers/delivery/ArticleContent';
import { ArticleForm } from '../../../containers/delivery/ArticleForm';
import { ArticleIngress } from '../../../containers/delivery/ArticleIngress';
import { ArticleList } from '../../../containers/delivery/ArticleList';
import { ArticleQuote } from '../../../containers/delivery/ArticleQuote';
import { ArticleText } from '../../../containers/delivery/ArticleText';
import { ArticleTypeImage } from '../../../containers/delivery/ArticleTypeImage';
import { ArticleVideo } from '../../../containers/delivery/ArticleVideo';
import { DeliveryContainer } from '../../../containers/delivery/Container';
import { useInflationContext } from '../../../../utils/hooks/useInflationContext';

const Article: React.FC = () => {
  const params = useParams<{ slug: string }>();
  const { getArticle } = useInflationContext();
  const article = getArticle(/* { slug: params.slug } */);

  return (
    <Page>
      <Seo
        title={article?.seo?.title}
        description={article?.seo?.description}
        image={article?.seo?.image}
      />
      {/*       {article?.video ? (
        <ArticleVideo video={article?.video} />
      ) : article?.image ? (
        <Hero
          imageUrl={article?.image}
          className="content-height flex padding-top-50"
          opacity={1}
          alt="bilde"
        ></Hero>
      ) : null} */}
      <ArticleContent>
        <DeliveryContainer>
          {/*           {article?.imageOverlay ? (
            <ArticleTypeImage
              src={article?.imageOverlay}
              alt="bilde-overlegg"
            />
          ) : null} */}
          <ButtonGroup style={{ margin: '2em 0 2em 0' }} className="center">
            <ButtonGroupColumn className="flex-center-mobile">
              <Button
                as="link"
                type="primary"
                colorTheme="gold"
                to={'/kampanje/vikoyr/main/'}
              >
                Tilbake til hovedside
              </Button>
            </ButtonGroupColumn>
            {/*             <ButtonGroupColumn className="flex-center-mobile">
              <Button
                as="link"
                type="primary"
                colorTheme="gold"
                to="/leveransebeskrivelse/fritid"
              >
                Fritidseiendom
              </Button>
            </ButtonGroupColumn> */}
          </ButtonGroup>
          <Heading tag="h2" center>
            {article?.title}
          </Heading>
          {article?.ingress ? (
            <ArticleIngress
              dangerouslySetInnerHTML={{ __html: article?.ingress }}
            />
          ) : null}
          {/*      {article?.quote ? <ArticleQuote quote={article?.quote} /> : null} */}
          {article?.content ? (
            <ArticleText
              dangerouslySetInnerHTML={{ __html: article?.content }}
            />
          ) : null}
          <ArticleList pagination />
          {/*      <ArticleForm /> */}
        </DeliveryContainer>
      </ArticleContent>
      <FooterOverride />
    </Page>
  );
};

export default Article;
